import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WorkNotes = ({ requestId }) => {
  const [expanded, setExpanded] = useState(false);
  const [notes, setNotes] = useState([]);
  const [currentNote, setCurrentNote] = useState('');

  const templates = [
    'Diagnosed issue - ',
    'Replaced part - ',
    'Performed maintenance - ',
    'Tested system - ',
    'Issue resolved - ',
    'Awaiting parts - ',
    'Customer notified - '
  ];

  const handleAddNote = () => {
    if (!currentNote?.trim()) {
      alert('Please enter a note');
      return;
    }

    const newNote = {
      id: Date.now(),
      text: currentNote,
      timestamp: new Date()?.toISOString()
    };

    setNotes(prev => [newNote, ...prev]);
    setCurrentNote('');
  };

  const handleTemplateClick = (template) => {
    setCurrentNote(template);
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date?.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-1 overflow-hidden">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between p-4 bg-muted/30 hover:bg-muted/50 transition-smooth"
      >
        <div className="flex items-center gap-2">
          <Icon name="FileText" size={20} color="var(--color-primary)" strokeWidth={2} />
          <h2 className="text-lg font-semibold text-foreground">Work Notes</h2>
          {notes?.length > 0 && (
            <span className="bg-primary text-primary-foreground text-xs font-bold px-2 py-0.5 rounded-full">
              {notes?.length}
            </span>
          )}
        </div>
        <Icon name={expanded ? 'ChevronUp' : 'ChevronDown'} size={20} strokeWidth={2} />
      </button>

      {expanded && (
        <div className="p-4 space-y-4">
          {/* Add Note */}
          <div className="space-y-3">
            <div>
              <label className="text-sm font-medium text-foreground mb-2 block">Add Work Note</label>
              <textarea
                value={currentNote}
                onChange={(e) => setCurrentNote(e?.target?.value)}
                placeholder="Document work performed, issues found, or next steps..."
                rows={3}
                className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              />
            </div>

            {/* Templates */}
            <div>
              <p className="text-xs text-muted-foreground mb-2">Quick Templates:</p>
              <div className="flex flex-wrap gap-2">
                {templates?.map((template, index) => (
                  <button
                    key={index}
                    onClick={() => handleTemplateClick(template)}
                    className="text-xs px-2 py-1 rounded-md bg-muted hover:bg-muted/80 text-foreground border border-border transition-smooth"
                  >
                    {template}
                  </button>
                ))}
              </div>
            </div>

            <Button
              variant="default"
              size="lg"
              iconName="Plus"
              iconPosition="left"
              onClick={handleAddNote}
              fullWidth
            >
              Add Note
            </Button>
          </div>

          {/* Notes List */}
          {notes?.length > 0 ? (
            <div className="space-y-2">
              <h3 className="text-sm font-semibold text-foreground">Work History</h3>
              <div className="space-y-2 max-h-96 overflow-y-auto">
                {notes?.map(note => (
                  <div key={note?.id} className="bg-muted/30 rounded-lg p-3">
                    <div className="flex items-start justify-between gap-2 mb-1">
                      <p className="text-xs text-muted-foreground">{formatTimestamp(note?.timestamp)}</p>
                    </div>
                    <p className="text-sm text-foreground">{note?.text}</p>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="text-center py-8">
              <Icon name="FileText" size={48} className="mx-auto text-muted-foreground mb-2" />
              <p className="text-sm text-muted-foreground">No work notes added yet</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default WorkNotes;